import React, { useState, Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, MapPin, Users, Clock, Award, Download, Share2, ArrowLeft, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Input } from '../components/ui/Input';
import { Dialog } from '../components/ui/Dialog';
import { useToast } from '../components/ui/Toast';
export function EventDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  // Mock event data
  const event = {
    id: 1,
    category: 'training',
    title: 'Advanced React & Next.js Workshop',
    description: 'Workshop intensif 2 hari tentang React dan Next.js untuk level advanced. Peserta akan belajar tentang Server Components, App Router, Data Fetching, dan best practices dalam membangun aplikasi production-ready.',
    fullDescription: `
      Workshop ini dirancang untuk developer yang sudah familiar dengan React dan ingin mendalami Next.js 13+ dengan App Router.
      
      Materi yang akan dipelajari:
      - Next.js App Router fundamentals
      - Server Components vs Client Components
      - Data Fetching strategies (SSR, SSG, ISR)
      - Route Handlers dan API Routes
      - Middleware dan Authentication
      - Performance optimization
      - Deployment best practices
      
      Persyaratan:
      - Familiar dengan React dan TypeScript
      - Memiliki laptop dengan Node.js terinstall
      - Pengalaman minimal 1 tahun sebagai frontend developer
    `,
    date: '15-16 Januari 2025',
    time: '09:00 - 17:00 WIB',
    location: 'Jakarta Tech Hub, Jl. Sudirman No. 123',
    type: 'offline',
    price: 'Rp 500.000',
    memberPrice: 'Rp 250.000',
    seats: 30,
    registered: 18,
    instructor: {
      name: 'John Doe',
      title: 'Senior Frontend Engineer',
      company: 'Tech Corp',
      bio: 'John adalah senior frontend engineer dengan 8+ tahun pengalaman. Aktif sebagai speaker dan contributor di komunitas React.',
      photo: 'JD'
    },
    certificate: true,
    status: 'open',
    agenda: [{
      day: 'Hari 1',
      items: [{
        time: '09:00 - 10:30',
        topic: 'Introduction to Next.js App Router'
      }, {
        time: '10:30 - 10:45',
        topic: 'Break'
      }, {
        time: '10:45 - 12:30',
        topic: 'Server Components Deep Dive'
      }, {
        time: '12:30 - 13:30',
        topic: 'Lunch Break'
      }, {
        time: '13:30 - 15:00',
        topic: 'Data Fetching Strategies'
      }, {
        time: '15:00 - 15:15',
        topic: 'Break'
      }, {
        time: '15:15 - 17:00',
        topic: 'Hands-on Project (Part 1)'
      }]
    }, {
      day: 'Hari 2',
      items: [{
        time: '09:00 - 10:30',
        topic: 'Route Handlers & API Routes'
      }, {
        time: '10:30 - 10:45',
        topic: 'Break'
      }, {
        time: '10:45 - 12:30',
        topic: 'Authentication & Middleware'
      }, {
        time: '12:30 - 13:30',
        topic: 'Lunch Break'
      }, {
        time: '13:30 - 15:00',
        topic: 'Performance Optimization'
      }, {
        time: '15:00 - 15:15',
        topic: 'Break'
      }, {
        time: '15:15 - 17:00',
        topic: 'Hands-on Project (Part 2) & Q&A'
      }]
    }]
  };
  const handleRegister = () => {
    setShowRegisterDialog(true);
  };
  const handleSubmitRegistration = (e: React.FormEvent) => {
    e.preventDefault();
    setIsRegistered(true);
    setShowRegisterDialog(false);
    showToast('success', 'Pendaftaran Berhasil!', 'Anda telah terdaftar untuk event ini. Cek email untuk detail lebih lanjut.');
  };
  const handleDownloadCertificate = () => {
    showToast('success', 'Sertifikat Diunduh', 'Sertifikat Anda sedang diunduh');
  };
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-2530">
      {/* Back Button */}
      <Button variant="ghost" onClick={() => navigate('/events')} data-id="element-2531">
        <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2532" />
        Kembali ke Events
      </Button>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2533">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-2534">
          {/* Header */}
          <Card data-id="element-2535">
            <CardHeader data-id="element-2536">
              <div className="flex items-start justify-between mb-4" data-id="element-2537">
                <Badge variant="success" data-id="element-2538">TRAINING</Badge>
                <div className="flex gap-2" data-id="element-2539">
                  <Button variant="outline" size="sm" data-id="element-2540">
                    <Share2 className="w-4 h-4" data-id="element-2541" />
                  </Button>
                </div>
              </div>
              <CardTitle className="text-2xl mb-2" data-id="element-2542">{event.title}</CardTitle>
              <p className="text-gray-400" data-id="element-2543">{event.description}</p>
            </CardHeader>
            <CardContent className="space-y-6" data-id="element-2544">
              {/* Event Info */}
              <div className="grid grid-cols-2 gap-4" data-id="element-2545">
                <div className="flex items-center gap-3" data-id="element-2546">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-2547">
                    <Calendar className="h-5 w-5 text-primary" data-id="element-2548" />
                  </div>
                  <div data-id="element-2549">
                    <p className="text-xs text-gray-500" data-id="element-2550">Tanggal</p>
                    <p className="text-sm font-medium text-white" data-id="element-2551">
                      {event.date}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2552">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-2553">
                    <Clock className="h-5 w-5 text-primary" data-id="element-2554" />
                  </div>
                  <div data-id="element-2555">
                    <p className="text-xs text-gray-500" data-id="element-2556">Waktu</p>
                    <p className="text-sm font-medium text-white" data-id="element-2557">
                      {event.time}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2558">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-2559">
                    <MapPin className="h-5 w-5 text-primary" data-id="element-2560" />
                  </div>
                  <div data-id="element-2561">
                    <p className="text-xs text-gray-500" data-id="element-2562">Lokasi</p>
                    <p className="text-sm font-medium text-white" data-id="element-2563">
                      {event.location}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2564">
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-2565">
                    <Users className="h-5 w-5 text-primary" data-id="element-2566" />
                  </div>
                  <div data-id="element-2567">
                    <p className="text-xs text-gray-500" data-id="element-2568">Peserta</p>
                    <p className="text-sm font-medium text-white" data-id="element-2569">
                      {event.registered}/{event.seats} terdaftar
                    </p>
                  </div>
                </div>
              </div>

              {/* Full Description */}
              <div className="pt-6 border-t border-gray-800" data-id="element-2570">
                <h3 className="text-lg font-bold text-white mb-3" data-id="element-2571">
                  Deskripsi Lengkap
                </h3>
                <div className="text-sm text-gray-400 whitespace-pre-line" data-id="element-2572">
                  {event.fullDescription}
                </div>
              </div>

              {/* Agenda */}
              <div className="pt-6 border-t border-gray-800" data-id="element-2573">
                <h3 className="text-lg font-bold text-white mb-4" data-id="element-2574">Agenda</h3>
                <div className="space-y-6" data-id="element-2575">
                  {event.agenda.map((day, i) => <div key={i} data-id="element-2576">
                      <h4 className="font-semibold text-white mb-3" data-id="element-2577">
                        {day.day}
                      </h4>
                      <div className="space-y-2" data-id="element-2578">
                        {day.items.map((item, j) => <div key={j} className="flex gap-4 text-sm" data-id="element-2579">
                            <span className="text-primary font-medium min-w-[120px]" data-id="element-2580">
                              {item.time}
                            </span>
                            <span className="text-gray-400" data-id="element-2581">{item.topic}</span>
                          </div>)}
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Instructor */}
              <div className="pt-6 border-t border-gray-800" data-id="element-2582">
                <h3 className="text-lg font-bold text-white mb-4" data-id="element-2583">
                  Instruktur
                </h3>
                <div className="flex items-start gap-4" data-id="element-2584">
                  <div className="h-16 w-16 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl" data-id="element-2585">
                    {event.instructor.photo}
                  </div>
                  <div data-id="element-2586">
                    <h4 className="font-semibold text-white" data-id="element-2587">
                      {event.instructor.name}
                    </h4>
                    <p className="text-sm text-gray-400" data-id="element-2588">
                      {event.instructor.title} at {event.instructor.company}
                    </p>
                    <p className="text-sm text-gray-500 mt-2" data-id="element-2589">
                      {event.instructor.bio}
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Sidebar */}
        <div className="space-y-6" data-id="element-2590">
          {/* Registration Card */}
          <Card className="sticky top-8" data-id="element-2591">
            <CardHeader data-id="element-2592">
              <CardTitle className="text-lg" data-id="element-2593">Pendaftaran</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-2594">
              {!isRegistered ? <>
                  <div data-id="element-2595">
                    <div className="flex items-center justify-between mb-2" data-id="element-2596">
                      <span className="text-sm text-gray-400" data-id="element-2597">
                        Harga Normal
                      </span>
                      <span className="text-sm text-gray-400 line-through" data-id="element-2598">
                        {event.price}
                      </span>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-2599">
                      <span className="text-sm font-medium text-white" data-id="element-2600">
                        Harga Member
                      </span>
                      <span className="text-2xl font-bold text-primary" data-id="element-2601">
                        {event.memberPrice}
                      </span>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-800" data-id="element-2602">
                    <div className="flex items-center justify-between text-sm mb-2" data-id="element-2603">
                      <span className="text-gray-400" data-id="element-2604">Kuota tersisa</span>
                      <span className="font-medium text-white" data-id="element-2605">
                        {event.seats - event.registered} dari {event.seats}
                      </span>
                    </div>
                    <div className="h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-2606">
                      <div className="h-full bg-primary rounded-full transition-all" style={{
                    width: `${event.registered / event.seats * 100}%`
                  }} data-id="element-2607" />
                    </div>
                  </div>

                  {event.certificate && <div className="flex items-center gap-2 text-sm text-gray-400 bg-gray-800/50 p-3 rounded-lg" data-id="element-2608">
                      <Award className="w-4 h-4 text-primary" data-id="element-2609" />
                      <span data-id="element-2610">
                        Sertifikat tersedia setelah menyelesaikan training
                      </span>
                    </div>}

                  <Button className="w-full" size="lg" onClick={handleRegister} data-id="element-2611">
                    Daftar Sekarang
                  </Button>
                </> : <div className="space-y-4" data-id="element-2612">
                  <div className="flex items-center gap-3 text-green-400 bg-green-500/10 p-4 rounded-lg border border-green-500/20" data-id="element-2613">
                    <CheckCircle className="w-6 h-6" data-id="element-2614" />
                    <div data-id="element-2615">
                      <p className="font-semibold" data-id="element-2616">Anda Terdaftar!</p>
                      <p className="text-xs text-gray-400" data-id="element-2617">
                        Cek email untuk detail lebih lanjut
                      </p>
                    </div>
                  </div>

                  <Button className="w-full" variant="outline" data-id="element-2618">
                    Lihat Detail Pendaftaran
                  </Button>

                  {event.certificate && <Button className="w-full" variant="outline" onClick={handleDownloadCertificate} data-id="element-2619">
                      <Download className="w-4 h-4 mr-2" data-id="element-2620" />
                      Download Sertifikat
                    </Button>}
                </div>}
            </CardContent>
          </Card>

          {/* Share Card */}
          <Card data-id="element-2621">
            <CardHeader data-id="element-2622">
              <CardTitle className="text-base" data-id="element-2623">Bagikan Event</CardTitle>
            </CardHeader>
            <CardContent data-id="element-2624">
              <div className="flex gap-2" data-id="element-2625">
                <Button variant="outline" size="sm" className="flex-1" data-id="element-2626">
                  WhatsApp
                </Button>
                <Button variant="outline" size="sm" className="flex-1" data-id="element-2627">
                  Twitter
                </Button>
                <Button variant="outline" size="sm" className="flex-1" data-id="element-2628">
                  LinkedIn
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Registration Dialog */}
      <Dialog isOpen={showRegisterDialog} onClose={() => setShowRegisterDialog(false)} title="Daftar Event" data-id="element-2629">
        <form onSubmit={handleSubmitRegistration} className="space-y-4" data-id="element-2630">
          <Input label="Nama Lengkap" placeholder="John Doe" required data-id="element-2631" />
          <Input label="Email" type="email" placeholder="john@example.com" required data-id="element-2632" />
          <Input label="Nomor Telepon" type="tel" placeholder="+62812345678" required data-id="element-2633" />
          <div className="pt-4 border-t border-gray-800" data-id="element-2634">
            <div className="flex items-center justify-between mb-4" data-id="element-2635">
              <span className="text-sm text-gray-400" data-id="element-2636">Total Pembayaran</span>
              <span className="text-xl font-bold text-primary" data-id="element-2637">
                {event.memberPrice}
              </span>
            </div>
            <Button type="submit" className="w-full" data-id="element-2638">
              Konfirmasi Pendaftaran
            </Button>
          </div>
        </form>
      </Dialog>
    </div>;
}